<div class="flex flex-wrap gap-1 items-center">
  @for (tag of incident.tags; track tag) {
    <app-tag  [tag]="tag" [editMode]="editMode"
    (remove)="removeTag($event)"></app-tag>
  }

  @if (!addingTag() && editMode) {
    <i class="pi pi-plus-circle" style="cursor:pointer" (click)="addTag()"></i>
  }

  @if (addingTag()) {
    <p-autoComplete [(ngModel)]="newTag" [suggestions]="suggestions()" [dropdown]="true" [autofocus]="true"
    (completeMethod)="search($event)" (onSelect)="tagSelected($event)"></p-autoComplete>
  }
  @if (networkActive()) {
    <i class="pi pi-spin pi-spinner" ></i>
  }
  @if (networkActive()) {
    <div class="absolute w-full h-full top-0 bg-surface-0 dark:bg-surface-900 opacity-80"></div>
  }
</div>